import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const loggingHabits = useStore((state) => state.loggingHabits);
  const setLoggingHabits = useStore((state) => state.setLoggingHabits);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.loggingHabits.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={loggingHabits}
          onChange={(value) => {
            setLoggingHabits(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'logging-habits',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Log food before eating"}>
            <span>🍎</span> {t('onboarding.loggingHabits.options.before')}
          </Option>
          <Option value={"Log food right after eating"}>
            <span>✅</span> {t('onboarding.loggingHabits.options.after')}
          </Option>
          <Option value={"Log all meals in the morning"}>
            <span>📅</span> {t('onboarding.loggingHabits.options.morning')}
          </Option>
          <Option value={"Log all meals at the end of the day"}>
            <span>🌙</span> {t('onboarding.loggingHabits.options.end')}
          </Option>
          <Option value={"I’m not sure yet"}>
            <span>🤔</span> {t('onboarding.loggingHabits.options.notSure')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
